export const APP_RESET_STORE = 'APP_RESET_STORE';
